module.exports = __webpack_public_path__ + "img/2_03.70f10ec8.jpg";